// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2247c","additionalInfo":"AgreementModal_additionalInfo__2uIvh"};